import React from 'react';
import {Route, Switch, Redirect} from 'react-router-dom';

import Collection from './components/Business_Cards';

import ErrorBoundaryRoute from '../../../../containers/ErrorBoundaryRoute';
import UserRoles from "../../../../constants/UserRoles";
import Object from "./components/Business_Card"

/*
	First is exact Route XYZ/
	Second is sub page(s) XYZ/ABC
	Third is sub page(s) with IDs XYZ/ABC/ID
	Last is non exact with ID. XYZ/ID
	Final is a redirect
 */
export default ({match, regions, roles, user, main_role}) => (
	<div>
		<Switch>
			<ErrorBoundaryRoute exact path={`${match.url}`}>
				<Collection regions={regions} roles={roles} user={user} main_role={main_role}/>
			</ErrorBoundaryRoute>

			<ErrorBoundaryRoute path={`${match.url}/:id`}>
				<Object regions={regions} baseUrl={match.url} isNew={false} user={user} main_role={main_role}/>
			</ErrorBoundaryRoute>
		</Switch>
	</div>
);
